/* eslint-disable jsx-a11y/no-static-element-interactions */

import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useWindowSize } from 'react-use';

import { closePopup } from '../../../store/slices/popupSlice';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import styles from './styles/styles.module.css';

function ModalWrapper({ popups }) {
  const { width } = useWindowSize();
  const activePopup = useAppSelector((state) => state.popup.activePopup);
  const isTopUpMobile = width < 480 && activePopup === 'topUpBalance';
  const popupProps = useAppSelector((state) => state.popup.popupProps);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  // Единая точка закрытия попапа - используется для клика по фону,
  // Escape и (через onCloseHref/onCloseClearOrderSession в props) может
  // повторять то же действие, что делает кнопка "Хорошо"/крестик внутри
  // самого попапа. Раньше клик по фону и Escape просто гасили попап,
  // тогда как кнопка внутри попапа могла ещё и делать навигацию/очистку
  // sessionStorage - из-за этого закрытие по фону выглядело как "заявка
  // не оформлена", хотя оформление уже прошло.
  const handleCloseModal = () => {
    const { onCloseHref, onCloseClearOrderSession } = popupProps || {};
    dispatch(closePopup());
    if (onCloseClearOrderSession) {
      sessionStorage.removeItem('order');
    }
    if (onCloseHref) {
      navigate(onCloseHref);
    }
  };

  useEffect(() => {
    const handleKeyDown = (evt) => {
      if (evt.key === 'Escape') {
        handleCloseModal();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [dispatch, popupProps]);

  if (!activePopup) return null;

  const PopupComponent = popups[activePopup];

  return (
    <div
      className={`
        ${styles.modalOverlay}
        ${activePopup ? styles.modalOverlay_visible : styles.modalOverlay_hidden}`}
      onClick={handleCloseModal}
      role="button"
      tabIndex="0"
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          handleCloseModal();
        }
      }}
      aria-hidden={!activePopup}
      inert={!activePopup}
    >
      <div
        className={`
          ${styles.modalContainer}
          ${isTopUpMobile ? styles.mobileTopUp : ''}
          `}
        onClick={(evt) => evt.stopPropagation()}
      >
        {PopupComponent && (
          <PopupComponent {...popupProps} onRequestClose={handleCloseModal} />
        )}
      </div>
    </div>
  );
}

export default ModalWrapper;

ModalWrapper.propTypes = {
  popups: PropTypes.objectOf(PropTypes.elementType).isRequired,
};
